/**
 * Copyright (C) 2020 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import Terminal, { TerminalDetails } from '../../../../shared/entities/terminal';

// get the all possible terminals from terminals on aircraft, in beam, and the ftv terminal
const getAllFtvTerminals = (fullTailViewTerminal: TerminalDetails | undefined) => {
  let terminals: Terminal[] = [];

  if (fullTailViewTerminal) {
    terminals = terminals.concat([fullTailViewTerminal]);

    if (fullTailViewTerminal.terminalsOnAircraft) {
      terminals = terminals.concat(fullTailViewTerminal.terminalsOnAircraft);
    }

    if (fullTailViewTerminal.terminalsInBeam) {
      terminals = terminals.concat(fullTailViewTerminal.terminalsInBeam);
    }
  }

  return terminals;
};

const getTerminalFromList = (datapathUuid: string, terminals: Terminal[]) => {
  let returnTerminal: Terminal | undefined;

  terminals.forEach((terminal: Terminal) => {
    if (terminal.datapathUuid === datapathUuid) {
      returnTerminal = terminal;
    }
  });

  return returnTerminal;
};

const getOtherTerminalsOnAircraft = (datapathUuid: string, terminals: Terminal[]) => {
  let otherTerminalsOnAircraft: any = [];
  let thisTerminal = getTerminalFromList(datapathUuid, terminals) as TerminalDetails;

  if (thisTerminal) {
    otherTerminalsOnAircraft = [];
    // get information to show tail tags for other terminals on the aircraft
    if (thisTerminal.terminalsOnAircraft && thisTerminal.terminalsOnAircraft.length > 0) {
      thisTerminal.terminalsOnAircraft.forEach((otherTerminal: Terminal) => {
        if (otherTerminal) {
          otherTerminalsOnAircraft.push(otherTerminal);
        }
      });
    } else if (thisTerminal.datapathUuidsOnAircraft && thisTerminal.datapathUuidsOnAircraft.length > 0) {
      thisTerminal.datapathUuidsOnAircraft.forEach((otherDatapathUuid: string) => {
        let otherTerminal = getTerminalFromList(otherDatapathUuid, terminals);

        if (otherTerminal) {
          otherTerminalsOnAircraft.push(otherTerminal);
        }
      });
    }
  }
  return otherTerminalsOnAircraft;
};

// This method takes in the terminal and other terminals on the aircraft and returns true if any of them are using a steerable beam, false if none are.
const getIfAnyTerminalsOnAircraftUsingSteerableBeam = (terminal: Terminal, otherTerminals: Terminal[] = []) => {
  return (
    terminal.isUsingSteerableBeam ||
    otherTerminals.find((terminalOnAircraft: Terminal) => terminalOnAircraft.isUsingSteerableBeam)
  );
};

export {
  getAllFtvTerminals,
  getIfAnyTerminalsOnAircraftUsingSteerableBeam,
  getOtherTerminalsOnAircraft,
  getTerminalFromList,
};
